import React from 'react';

interface CustomIconProps {
  width?: string;
}

const PlayWithoutRing: React.FC<CustomIconProps> = ({ width }) => (
  <svg
    width={width ?? '24'}
    height={width ?? '24'}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.376 12.4161L8.777 19.4821C8.70171 19.5322 8.61423 19.5609 8.52389 19.5652C8.43355 19.5696 8.34373 19.5493 8.264 19.5066C8.18427 19.4639 8.1176 19.4004 8.07111 19.3228C8.02462 19.2452 8.00005 19.1565 8 19.0661V4.93407C8.00005 4.84363 8.02462 4.75489 8.07111 4.67731C8.1176 4.59973 8.18427 4.53622 8.264 4.49353C8.34373 4.45084 8.43355 4.43058 8.52389 4.4349C8.61423 4.43922 8.70171 4.46796 8.777 4.51807L19.376 11.5841C19.4445 11.6297 19.5006 11.6916 19.5395 11.7642C19.5783 11.8367 19.5986 11.9178 19.5986 12.0001C19.5986 12.0824 19.5783 12.1634 19.5395 12.236C19.5006 12.3085 19.4445 12.3704 19.376 12.4161Z'
      fill='white'
    />
  </svg>
);

export default PlayWithoutRing;
